window.Kinderly = window.Kinderly || {};

window.Kinderly.initClientLogoSection = function (section) {
    if (!section || section.__clientLogoSectionInitialized) return;
    section.__clientLogoSectionInitialized = true;

    const svg = section.querySelector(`#rope-svg-${section.id}`);
    const path = section.querySelector(`#rope-path-${section.id}`);
    const wrappers = Array.from(section.querySelectorAll('.client-logo-slider-wrapper'));
    const slides = Array.from(section.querySelectorAll('.client-logo-slide'));
    if (!svg || !path || wrappers.length === 0 || slides.length === 0) return;

    const pathLength = path.getTotalLength();
    const samples = 200;
    const points = [];

    for (let i = 0; i <= samples; i++) {
        const pt = path.getPointAtLength((i / samples) * pathLength);
        points.push({ x: pt.x, y: pt.y });
    }

    function getYForX(x) {
        if (x <= points[0].x) return points[0].y;
        if (x >= points[points.length - 1].x) return points[points.length - 1].y;

        for (let i = 0; i < points.length - 1; i++) {
            if (x >= points[i].x && x <= points[i + 1].x) {
                const t = (x - points[i].x) / (points[i + 1].x - points[i].x);
                return points[i].y + t * (points[i + 1].y - points[i].y);
            }
        }

        return points[0].y;
    }

    const slideMeta = slides.map(slide => {
        const wrapperElement = slide.closest('.client-logo-slider-wrapper');
        return {
            slide,
            wrapper: wrapperElement,
            width: 0,
            left: 0,
            card: slide.querySelector('.card-style')
        };
    }).filter(meta => meta.wrapper);

    requestAnimationFrame(() => {
        slideMeta.forEach(meta => {
            meta.width = meta.slide.offsetWidth;
            meta.left = meta.slide.offsetLeft;
        });
        computeTransforms();
    });

    let isSectionInView = false;
    if (window.Shopify && window.Shopify.designMode) {
        isSectionInView = true;
    }
    const sectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (window.Shopify && window.Shopify.designMode) {
                isSectionInView = true;
            } else {
                isSectionInView = entry.isIntersecting;
            }
            if (isSectionInView) computeTransforms();
        });
    }, { threshold: 0.01 });

    sectionObserver.observe(section);

    function computeTransforms() {
        if (!isSectionInView) return;
        const svgRect = svg.getBoundingClientRect();
        const wrapperRects = new Map(wrappers.map(wrapper => [wrapper, wrapper.getBoundingClientRect()]));
        
        if (svgRect.width === 0) {
            requestAnimationFrame(computeTransforms);
            return;
        }

        const isMobile = window.innerWidth <= 767;
        const currentViewBoxWidth = isMobile ? 1433 : 1440;
        const currentViewBoxHeight = isMobile ? 69 : 120;
        const delta = 5;

        slideMeta.forEach(({ slide, wrapper: slideWrapper, width, left, card }) => {
            const wrapperRect = wrapperRects.get(slideWrapper);
            if (!wrapperRect || wrapperRect.width === 0) return;

            const centerX = wrapperRect.left + left + width / 2 - svgRect.left;
            const normalizedX = (((centerX / svgRect.width) * currentViewBoxWidth) % currentViewBoxWidth + currentViewBoxWidth) % currentViewBoxWidth;
            const targetYViewBox = getYForX(normalizedX);

            let targetYPixelOffsetInSVG;
            let hangerOffset;

            if (isMobile) {
                const svgAspect = 1433 / 69;
                const actualRopeHeight = svgRect.width / svgAspect;
                const contentTopOffset = (svgRect.height - actualRopeHeight) / 2;
                targetYPixelOffsetInSVG = contentTopOffset + (targetYViewBox / currentViewBoxHeight) * actualRopeHeight;
                hangerOffset = 12;
            } else {
                targetYPixelOffsetInSVG = (targetYViewBox / currentViewBoxHeight) * svgRect.height;
                hangerOffset = 20;
            }

            const targetYScreen = svgRect.top + targetYPixelOffsetInSVG;
            const translateY = targetYScreen - wrapperRect.top - hangerOffset;
            const normalizedRotateX = (((centerX / svgRect.width) * 1440) % 1440 + 1440) % 1440;
            const y1 = getYForX((normalizedRotateX - delta + 1440) % 1440);
            const y2 = getYForX((normalizedRotateX + delta) % 1440);
            const slope = (y2 - y1) / (delta * 2);
            const angle = Math.atan(slope) * (180 / Math.PI);

            if (card) {
                card.style.transform = `rotate(${angle}deg)`;
            }
            slide.style.transform = `translate3d(0, ${translateY}px, 0)`;
        });
    }

    const resizeHandler = () => {
        requestAnimationFrame(() => {
            slideMeta.forEach(item => {
                item.width = item.slide.offsetWidth;
                item.left = item.slide.offsetLeft;
            });
            if (isSectionInView) computeTransforms();
        });
    };

    const debouncedResize = function () {
        clearTimeout(section._clientLogoResizeTimeout);
        section._clientLogoResizeTimeout = setTimeout(resizeHandler, 100);
    };

    window.addEventListener('resize', debouncedResize, { passive: true });

    if ('ResizeObserver' in window) {
        section._clientLogoResizeObserver = new ResizeObserver(debouncedResize);
        section._clientLogoResizeObserver.observe(section);
    }

    section._clientLogoUnloadHandler = function (e) {
        if (e.target === section || e.target.id === section.id || e.target.contains(section)) {
            window.removeEventListener('resize', debouncedResize, { passive: true });
            sectionObserver.disconnect();
            if (section._clientLogoResizeObserver) {
                section._clientLogoResizeObserver.disconnect();
                section._clientLogoResizeObserver = null;
            }
        }
    };

    document.addEventListener('shopify:section:unload', section._clientLogoUnloadHandler);

};

function registerClientLogoSection() {
    if (typeof window.Kinderly === 'undefined' || typeof window.Kinderly.initSection !== 'function') {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', registerClientLogoSection);
        } else {
            setTimeout(registerClientLogoSection, 50);
        }
        return;
    }

    window.Kinderly.initSection('.client-logo-section', window.Kinderly.initClientLogoSection);
}

registerClientLogoSection();

